export enum StepEnum {
  clinic = 0,
  dateTime = 1,
  confirm = 2,
}

export const TOTAL_STEPS = 3
